<template>
    <div class="tab_grid theme_tab-formats" :key="dataLoaded">
        <div
            v-for="(format, index) in formats"
            :key="index"
            class="theme_tab-formats-item"
        >
            <div class="theme_tab-title">
                <span>{{ format.formatName }}</span>
                <span @click="showFormatProjects(format)">{{ $t('editorTabShow') }}</span>
            </div>
            <div
                v-for="project in format.projects"
                :key="project.id"
                v-show="project.page.pageData !== null"
                :style="boxStyle(format)"
                class="theme_tab-formats-item-box"
            >
                <div
                    :style="{ backgroundImage: `url(${project.page.pageData.thumbnailUrl})` }"
                    @click="showProjectPages(project, format)"
                    class="theme_tab-formats-item-img"
                >
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import { RepositoryFactory } from '../../../repositories/repositoryFactory.js';
    const FormatRepository = RepositoryFactory.get('formats');
    const ProjectRepository = RepositoryFactory.get('projects');

    export default {
        data() {
            return {
                formats: [],
                dataLoaded: 0
            }
        },
        computed: {
            ...mapGetters([
                'getTemplateFormat',
                'getProject',
                'getCurrentPage'
            ]),
            ...mapState([
                'sessionToken'
            ])
        },
        methods: {
            showFormatProjects(format) {
                this.$store.dispatch('SET_ACTIVE_FORMAT_IN_THEME_TAB', { id: format.formatId, name: format.formatName, width: format.width, height: format.height });
                this.$store.dispatch('SET_ACTIVE_THEME_TAB', 'activeFormatProjects');
            },
            showProjectPages(project, format) {
                this.$store.dispatch('SET_ACTIVE_PROJECT_IN_THEME_TAB', project.id);
                this.$store.dispatch('SET_ACTIVE_FORMAT_IN_THEME_TAB', { id: format.formatId, name: format.formatName, width: format.width, height: format.height });
                this.$store.dispatch('SET_ACTIVE_THEME_TAB', 'activeProjectPages');
            },
            boxStyle(format) {
                const ratio = format.width / format.height;
                let widthNew, heightNew;

                if (ratio > 1) {
                    widthNew = 115;
                    heightNew = 115 / ratio;
                } else if (ratio < 1) {
                    heightNew = 155;
                    widthNew = 155 * ratio;
                } else {
                    heightNew = 115;
                    widthNew = 115;
                }

                return `width: ${widthNew}px; height: ${heightNew}px;`
            }
        },
        async created() {
            const headers = {
                'api-key' : 'session',
                'api-sign' : this.sessionToken.token
            }
            try {
                const formatsListRequest = await FormatRepository.get(headers);
                const formatsList = formatsListRequest.data.data.entities;

                formatsList.forEach(format => {
                    if (format.projects.length > 0) {
                        const formatData = {
                            formatId: format.id,
                            formatName: format.name,
                            width: format.pageWidth,
                            height: format.pageHeight,
                            projects: format.projects
                        }
                        this.formats = [
                            ...this.formats,
                            formatData
                        ]
                    }
                    
                });

                let promises = [];
                let projectIds = [];
                this.formats.forEach(format => {
                    const projectPromises = format.projects.map(project => {
                        projectIds.push(project.id);
                        return ProjectRepository.getProjectPage(project.id, 1, headers);
                    })

                    promises.push(...projectPromises);
                })

                // const projectData = await ProjectRepository.getProject(project.id, headers);

                let pages = await Promise.all(promises);

                
                pages = pages.map((page, index) => {
                    let pageData;

                    if (page.data.success === true) {
                        pageData = {
                            thumbnailUrl: page.data.data.thumbnailUrl,
                            thumbnailHeight: page.data.data.thumbnailHeight,
                            thumbnailWidth: page.data.data.thumbnailWidth
                        }
                    } else {
                        pageData = null;
                    }

                    return {
                        pageData,
                        projectId: projectIds[index]
                    }
                    
                })
                this.formats.forEach(format => {
                    format.projects.forEach(project => {
                        const page = pages.find(page => page.projectId === project.id);
                        project.page = page;
                    })
                })

                this.dataLoaded += 1;
            }
            catch (err) {
                // Handle errors
            }
        }
    }
</script>

<style lang="scss">
    .theme_tab-title {
        width: 100%;
        display: flex;
        justify-content: space-between;
    }
    .theme_tab-formats-item {
        display: flex;
        flex-wrap: wrap;
    }
    .theme_tab-formats-item-box {
        margin: 8px 8px 8px 0;
    }
    .theme_tab-formats-item-img {
        width: 100%;
        height: 100%;
        
        border-radius: 8px;
        cursor: pointer;
        position: relative;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: cover;
    }
</style>